import { Injectable } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ShareddialogComponent } from '../components/shareddialog/shareddialog.component';
import { MobileBridgeService } from '../../../services/mobile-bridge.service';
import { MOBILE_BRIDGE_EVENT_SEND } from '../../../constants/mobile-bridge.constant';

@Injectable({ providedIn: 'root' })
export class ShareDialogService {
  constructor(
    private readonly modalService: BsModalService,
    private readonly mobileBridgeService: MobileBridgeService
  ) {}

  openShareDialog(modalInfo: any, options?: { backdrop?: string }): BsModalRef | void {
    if (this.mobileBridgeService.isMobileApp) {
      this.mobileBridgeService.sendMessage(
        MOBILE_BRIDGE_EVENT_SEND.NATIVE_SHARE,
        modalInfo
      );
      return;
    }
    const backdrop = options?.backdrop || 'static';
    return this.modalService.show(ShareddialogComponent, {
      initialState: modalInfo,
      backdrop: backdrop as boolean | 'static' | undefined,
    });
  }
} 